import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {SelectButton} from "primeng/selectbutton";
import {IncomeOption, incomeOptions} from "../../model/user";
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import {definePreset} from "@primeng/themes";
import {MyPreset} from "../../theme";
import {TranslocoPipe} from "@jsverse/transloco";

@Component({
  selector: 'homey-income-option-select',
  standalone: true,
  imports: [
    SelectButton,
    FormsModule,
    ReactiveFormsModule,
    TranslocoPipe
  ],
  templateUrl: './income-option-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './income-option-select.component.css'
})
export class IncomeOptionSelectComponent {
  public readonly control = input.required<FormControl<IncomeOption | undefined>>();

  protected readonly dt = definePreset(
    MyPreset,
    {
      togglebutton: {
        colorScheme: {
          border: {
            color: '{surface.200}',
          },
          background: 'white',
          light: {
            checkedBackground: 'white',
            checkedBorderColor: '{surface.200}',
            content: {
              checkedBackground: '{surface.200}',
            }
          }
        }
      },
    }
  )

  private labelMappings: Record<IncomeOption, string> = {
    '20000-50000': "$20,000 $50,000",
    '50000-100000': "$50,000 $100,000",
    '100000-150000': "$100,000 $150,000",
    '150000-240000': "$150,000 $240,000"
  };

  private toSelectOption = (incomeOption: IncomeOption) => {
    return {
      value: incomeOption,
      label: this.labelMappings[incomeOption]
    };
  }
  protected readonly incomeOptions: { value: IncomeOption, label: string }[] = incomeOptions.map(this.toSelectOption);
  protected selectedOption?: IncomeOption;
}
